import { useAuth0 } from "@auth0/auth0-react";
import React, { useState } from "react";
import { redirect, useNavigate } from "react-router-dom";
import styled from "styled-components";

import "react-notifications-component/dist/theme.css";
import { Store } from "react-notifications-component";

const Feedback = () => {
  const { user, isAuthenticated, isLoading } = useAuth0();
  const [email, setEmail] = useState("");
  const [feedback, setFeedback] = useState("");
  const navigate = useNavigate();

  if (isAuthenticated && user && user["email"].includes("student")) {
    return navigate("/");
  }

  function handleSubmit(e) {
    e.preventDefault();
    // fetch(`${process.env.REACT_APP_BACKEND}/feedback`, {
    //   method: "POST",
    //   headers: {
    //     Accept: "application/json, text/plain, */*",
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify({
    //     text: feedback,
    //     creator: "ead11f",
    //     receiver: email,
    //   }),
    // });
    // .then((res) => res.json())
    // .then((res) => console.log(res));
    Store.addNotification({
      title: "Feedback Sent",
      message:
        "This feedback will be used for the improvement of the candidate's performance",
      type: "success",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
      },
    });
    setTimeout(() => {
      setEmail("");
      setFeedback("");
      return navigate("/");
    }, 4500);
  }
  return (
    <FeedbackWrapper>
      <div
        style={{
          // border: "1px solid red",
          height: "90vh",
          display: "grid",
          placeItems: "center",
        }}
      >
        <div className="form">
          <form className="login-form">
            <h4 style={{ marginBottom: "0.5em" }}>
              Please submit Feedback for the student
            </h4>
            <input
              type="email"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
            <input
              type="text"
              placeholder="Feedback"
              onChange={(e) => setFeedback(e.target.value)}
              value={feedback}
            />
            <button onClick={(e) => handleSubmit(e)}>Submit</button>
          </form>
        </div>
      </div>
    </FeedbackWrapper>
  );
};

const FeedbackWrapper = styled.div`
  @import url(https://fonts.googleapis.com/css?family=Roboto:300);

  .login-page {
    width: 360px;
    padding: 8% 0 0;
    margin: auto;
  }
  .form {
    scale: 1.2;
    position: relative;
    z-index: 1;
    background: #ffffff;
    max-width: 360px;
    margin: 0 auto 100px;
    padding: 45px;
    text-align: center;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
  }
  .form input {
    font-family: "Roboto", sans-serif;
    outline: 0;
    background: #f2f2f2;
    width: 100%;
    border: 0;
    margin: 0 0 15px;
    padding: 15px;
    box-sizing: border-box;
    font-size: 14px;
  }
  .form button {
    font-family: "Roboto", sans-serif;
    text-transform: uppercase;
    outline: 0;
    background: #ed4136;
    width: 100%;
    border: 0;
    padding: 15px;
    color: #ffffff;
    font-size: 14px;
    -webkit-transition: all 0.3 ease;
    transition: all 0.2s ease;
    cursor: pointer;
  }
  .form button:hover,
  .form button:active,
  .form button:focus {
    scale: 1.1;
  }
  .form .message {
    margin: 15px 0 0;
    color: #b3b3b3;
    font-size: 12px;
  }
  .form .message a {
    color: #4caf50;
    text-decoration: none;
  }
  .form .register-form {
    display: none;
  }
  .container {
    position: relative;
    z-index: 1;
    max-width: 300px;
    margin: 0 auto;
  }
  .container:before,
  .container:after {
    content: "";
    display: block;
    clear: both;
  }
  .container .info {
    margin: 50px auto;
    text-align: center;
  }
  .container .info h1 {
    margin: 0 0 15px;
    padding: 0;
    font-size: 36px;
    font-weight: 300;
    color: #1a1a1a;
  }
  .container .info span {
    color: #4d4d4d;
    font-size: 12px;
  }
  .container .info span a {
    color: #000000;
    text-decoration: none;
  }
  .container .info span .fa {
    color: #ef3b3a;
  }
  body {
    background: #76b852; /* fallback for old browsers */
    background: rgb(141, 194, 111);
    background: linear-gradient(
      90deg,
      rgba(141, 194, 111, 1) 0%,
      rgba(118, 184, 82, 1) 50%
    );
    font-family: "Roboto", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;
export default Feedback;
